// extracted by mini-css-extract-plugin
export default {"button":"TheButton_button__E8TXU","primary":"TheButton_primary__aA6vC","secondary":"TheButton_secondary__IQgzb"};